import { rfqHeaderFactRows, type RfqHeaderFactRow, type RfqHeaderFacts } from '../../utils/rfqHeaderFactRows';

/**
 * The RFQ as GET /quotations/:id populates it, so far as the header reads it: the subject, the vessel
 * and the buyer's own facts. A save answers with the quotation alone (`rfqId` a bare id), so the page
 * holds this apart from its quotation and reads the whole header off it.
 */
export type HeaderRfq = { subject?: string | null; vesselName?: string | null } & RfqHeaderFacts;

type RfqRef = string | HeaderRfq | null | undefined;

/**
 * D104.12: the vessel the quotation is for - its own snapshot first, then the populated RFQ. The rule is
 * the mirrored util's, which the server's PDFs and Excel read too; this header, the send form and the
 * Client view keep no spelling of it.
 */
export { quotationVesselName } from '../../utils/quotationVessel';

/**
 * What the buyer's own document says about the request (their RFQ / order number, port, dates, currency),
 * for the header beside the vessel: the facts the populated RFQ holds, in the order every screen shows them
 * (`rfqHeaderFactRows`, the same rows the inbox RFQ panel builds). None, never a placeholder, for a
 * quotation whose RFQ is only an id or states none.
 */
export function quotationRfqFactRows(q: { rfqId?: RfqRef }): RfqHeaderFactRow[] {
  return q.rfqId && typeof q.rfqId === 'object' ? rfqHeaderFactRows(q.rfqId) : [];
}

/** D104.13: the browser tab names the quotation, not the uploaded file the request came in as. */
export function quotationTabTitle(quotationNumber: string | null | undefined): string {
  return (quotationNumber || '').trim() || 'Quotation';
}
